<script setup lang="ts">
// import dayjs from 'dayjs'
// import zhcn from 'dayjs/locale/zh-cn'
import { getStockEFTList } from '@/api/modules/home'
// import notice from '@/components/Notice'

definePage({
  name: 'stock-eft',
  meta: {
    title: '港股通 ETF',
  },
})

const list = ref([]) as any
const loading = ref(false)
const finished = ref(false)

async function onLoad() {
  try {
    const { status, data } = await getStockEFTList({
      page: 1,
    })
    if (status === 1) {
      list.value = data.list
      finished.value = data.finished
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <FmPageLayout navbar back class="fluctuation-page" :search="false">
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="bg-[#fff]">
        <Notice />
        <vxe-table
          header-row-class-name="table-header"
          :data="list"
        >
          <vxe-column field="name" title="名称" fixed="left" width="25%" sortable>
            <template #default="{ row }">
              <div class="text-15px font-500">
                {{ row.name }}
              </div>
              <div class="text-13px">
                {{ row.code }}
              </div>
            </template>
          </vxe-column>
          <vxe-column field="price" title="现价" width="25%" sortable>
            <template #default="{ row }">
              <div class="text-15px font-500" :style="{ color: '#E51A2D' }">
                {{ row.price }}
              </div>
            </template>
          </vxe-column>
          <vxe-column field="per" title="涨跌幅" width="25%" sortable>
            <template #default="{ row }">
              <div class="text-15px font-500" :style="{ color: '#E51A2D' }">
                {{ row.per }}
              </div>
            </template>
          </vxe-column>
          <vxe-column width="25%" field="data" title="成交量" sortable />
          <vxe-column width="25%" field="prc" title="振幅" sortable />
          <vxe-column width="25%" field="num" title="量比" sortable />
          <vxe-column width="25%" field="nums" title="委比" sortable align="right" />
        </vxe-table>
      </div>
    </van-list>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }

  .active-card {
    color: #fff;
    background-color: #3c78ff;
    border-color: #3c78ff !important;
  }
}
</style>
